const getItem = (item) => {
  if (item) {
    return window.localStorage.getItem(item)
  }
  return null
}

const setItem = (item, value) => {
  if (item && value) {
    window.localStorage.setItem(item, value)
  }
}

const removeItem = (item) => {
  if (item) {
    window.localStorage.removeItem(item)
  }
}

const getAllKeys = () => {
  let entries = Object.entries(localStorage)
  let result = []
  entries.forEach(elm => {
    result.push(elm[0])
  })
  return result
}

const hasKey = (item) => {
  let entries = Object.entries(localStorage)
  return entries.indexOf(item) >= 0
}

const removeUserData = () => {
  removeItem('user')
  removeItem('refreshToken')
  removeItem('email')
  removeItem('accessToken')
  removeItem('hasAccountType')
}

export {
  getItem,
  setItem,
  removeItem,
  getAllKeys,
  hasKey,
  removeUserData
}
